;(function(){
  document.querySelectorAll("bb-collection-product-show").forEach(component => {
    console.log("component:", component)
    const menuItems = component.querySelectorAll('.bb-collection-product-show-menu-item')
    const productLists = component.querySelectorAll('.bb-collection-product-show-container')
    const productSwipers = component.querySelectorAll('.bb-collection-product-show-list')

    initSwiper(productSwipers)
    init()

    window.addEventListener('resize', initSwiper(productSwipers))

    function initSwiper(productSwipers) {
      console.log(productSwipers)
        productSwipers.forEach(productSwiper => {
            new Swiper(productSwiper, {
                slidesPerView: window.innerWidth >= 960 ? 4 : 2.15,
                grid: {
                    fill: 'row',
                    rows: 1,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            })
        })
    }

    function init() {
            menuItems.forEach(item => {
                item.addEventListener('click', () => {
                    menuItems.forEach((item_) => {
                        item_.removeAttribute('active')
                    })
                    item.setAttribute('active', true)
                    productLists.forEach((list) => {
                        list.removeAttribute('active')
                    })
                    productLists.forEach((list) => {
                        if (list.getAttribute('data-collection') === item.getAttribute('data-collection')) {
                            list.setAttribute('active', true)
                        }
                    })
                })
            })
        }
    
  })
})();

// defineCustomElement(
//     'bb-collection-product-show',
//     () =>
//     class BBCollectionProductShow extends HTMLElement {
//         constructor() {
//             super()
//             this.menuItems = this.querySelectorAll('.bb-collection-product-show-menu-item')
//             this.productLists = this.querySelectorAll('.bb-collection-product-show-container')
//             this.productSwipers = this.querySelectorAll('.bb-collection-product-show-list')

//             this.initSwiper()
//             this.init()

//             window.addEventListener('resize', this.initSwiper.bind(this))
//         }

//         initSwiper() {
//             this.productSwipers.forEach(productSwiper => {
//                 new Swiper(productSwiper, {
//                     slidesPerView: window.innerWidth >= 960 ? 4 : 2.15,
//                     grid: {
//                         fill: 'row',
//                         rows: 1,
//                     },
//                     navigation: {
//                         nextEl: '.swiper-button-next',
//                         prevEl: '.swiper-button-prev',
//                     },
//                 })
//             })
//         }

//         init() {
//             this.menuItems.forEach(item => {
//                 item.addEventListener('click', () => {
//                     this.menuItems.forEach((item_) => {
//                         item_.removeAttribute('active')
//                     })
//                     item.setAttribute('active', true)
//                     this.productLists.forEach((list) => {
//                         list.removeAttribute('active')
//                     })
//                     this.productLists.forEach((list) => {
//                         if (list.getAttribute('data-collection') === item.getAttribute('data-collection')) {
//                             list.setAttribute('active', true)
//                         }
//                     })
//                 })
//             })
//         }
//     }
// )